import { Select, SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";
import { TipoIntervaloRepeticaoEnum } from "core/features/manutencao/typings";

const { Option } = Select;

export interface SelectTipoIntervaloRepeticaoProps<T = any>
  extends SelectProps<T> {
  value: any;
  isInvalid?: boolean;
  onChange: (v: any) => void;
  hideOptions?: ("diaria" | "semanal" | "mensal" | "anual")[];
}

function SelectTipoIntervaloRepeticao({
  value,
  isInvalid,
  onChange,
  hideOptions,
  ...rest
}: SelectTipoIntervaloRepeticaoProps) {
  const showDiaria = !hideOptions?.includes("diaria");
  const showSemanal = !hideOptions?.includes("semanal");
  const showMensal = !hideOptions?.includes("mensal");
  const showAnual = !hideOptions?.includes("anual");

  return (
    <>
      <SelectBaseAntd
        isInvalid={isInvalid}
        size="large"
        getPopupContainer={(node) => node.parentNode}
        placeholder="Tipo de recorrência"
        style={{ width: "100%" }}
        value={value}
        showSearch={false}
        allowClear={false}
        onChange={(ev) => {
          onChange(ev);
        }}
        {...rest}
      >
        {showDiaria ? (
          <Option value={TipoIntervaloRepeticaoEnum.Diaria} key="d">
            Diária
          </Option>
        ) : null}
        {showSemanal ? (
          <Option value={TipoIntervaloRepeticaoEnum.Semanal} key="s">
            Semanal
          </Option>
        ) : null}
        {showMensal ? (
          <Option value={TipoIntervaloRepeticaoEnum.Mensal} key="m">
            Mensal
          </Option>
        ) : null}
        {showAnual ? (
          <Option value={TipoIntervaloRepeticaoEnum.Anual} key="a">
            Anual
          </Option>
        ) : null}
      </SelectBaseAntd>
    </>
  );
}

export default SelectTipoIntervaloRepeticao;
